import { defineComponent as o, createBlock as r, createCommentVNode as t, openBlock as n, unref as a, withCtx as s, createTextVNode as p, toDisplayString as i } from "vue";
import m from "../../../../components/Badge/Badge.vue.js";
const d = /* @__PURE__ */ o({
  __name: "OpenApiVersion",
  props: {
    oasVersion: {}
  },
  setup(c) {
    return (e, f) => e.oasVersion ? (n(), r(a(m), { key: 0 }, {
      default: s(() => [
        p("OAS " + i(e.oasVersion), 1)
      ]),
      _: 1
    })) : t("", !0);
  }
});
export {
  d as default
};
